// Shared persona definitions — used across Login quick-login, Personas page,
// and matched by the backend against these persona keys.
export const PERSONAS = [
  {
    key: "lea.martin",
    email: "lea.martin@maisonea.fr",
    first_name: "Léa",
    last_name: "Martin",
    display_name: "Léa Martin",
    role: "Vendeuse",
    site: "Magasin Lyon Part-Dieu",
    contract: "CDI",
    region: "Sud",
    summary: "6 mois d'ancienneté · Managée par Thomas Dubois",
  },
  {
    key: "thomas.dubois",
    email: "thomas.dubois@maisonea.fr",
    first_name: "Thomas",
    last_name: "Dubois",
    display_name: "Thomas Dubois",
    role: "Manager Magasin",
    site: "Magasin Bordeaux Mériadeck",
    contract: "CDI",
    region: "Ouest",
    summary: "8 ans d'ancienneté · Manage 12 personnes",
  },
  {
    key: "sarah.benali",
    email: "sarah.benali@maisonea.fr",
    first_name: "Sarah",
    last_name: "Benali",
    display_name: "Sarah Benali",
    role: "Vendeuse Saisonnière",
    site: "Magasin Nice Masséna",
    contract: "CDD",
    region: "Sud",
    summary: "CDD saisonnier · Se termine dans 2 mois",
  },
  {
    key: "marc.lefort",
    email: "marc.lefort@maisonea.fr",
    first_name: "Marc",
    last_name: "Lefort",
    display_name: "Marc Lefort",
    role: "Consultant IT",
    site: "Siège Paris La Défense",
    contract: "Freelance",
    region: "Île-de-France",
    summary: "Freelance · Fin de mission dans 4 mois",
  },
  {
    key: "elodie.rousseau",
    email: "elodie.rousseau@maisonea.fr",
    first_name: "Élodie",
    last_name: "Rousseau",
    display_name: "Élodie Rousseau",
    role: "Directrice Régionale",
    site: "Siège Paris La Défense",
    contract: "CDI",
    region: "Sud",
    summary: "12 ans d'ancienneté · Manage les managers du Sud",
  },
];

export const avatarUrl = (key) =>
  `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(key)}&backgroundColor=E8D5C4&textColor=2C2420&fontFamily=Fraunces`;

// Admin quick-login card shown above the persona list.
// Credentials are NOT stored client-side — the Login page calls the dedicated
// backend endpoint /api/auth/admin-quick-login which resolves the seeded admin
// from the database (demo mode only).
export const ADMIN_QUICK = {
  key: "admin",
  display_name: "Administrateur",
  role: "Admin SIRH",
  site: "Accès complet · Référentiels, API, logs",
};

export const BRAND_LOGO =
  "https://customer-assets.emergentagent.com/job_nim-source/artifacts/tduvehba_FreeSample-Vectorizer-io-ChatGPT%20Image%2024%20avr.%202026%2C%2018_11_03.svg";
export const BRAND_FAVICON =
  "https://customer-assets.emergentagent.com/job_nim-source/artifacts/lv3rw234_favicon.ico";
